export const spacingXXXS = '3px';
export const spacingXXS = '8px';
export const spacingXS = '18px';
export const spacingS = '30px';
export const spacingM = '50px';
export const spacingL = '80px';
export const spacingXL = '130px';
export const spacingXXL = '300px';
